/**
 * Nach einem Seitenwechsel (z. B. aus der Suche) zu einem Abschnitt springen und ihn kurz
 * aufleuchten lassen. Wartet, bis das Element existiert (Seiten laden teils nach) und bis
 * der Scroll-Reset des Server-Arbeitsbereichs durch ist.
 */
export const scrollToSection = (id: string, timeoutMs = 5000) => {
  const started = Date.now();
  const tick = () => {
    const el = document.getElementById(id);
    if (!el) {
      if (Date.now() - started < timeoutMs) setTimeout(tick, 100);
      return;
    }
    setTimeout(() => {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      el.animate?.(
        [{ backgroundColor: 'rgba(255, 106, 61, 0.14)' }, { backgroundColor: 'rgba(255, 106, 61, 0)' }],
        { duration: 1800, easing: 'ease-out' },
      );
    }, 180);
  };
  setTimeout(tick, 60);
};
